import { Feature, Point } from "geojson";
import { Marker, Popup } from "maplibre-gl";
import { LayerParams } from "src/app/instant-analysis/map/layer-manager";
import { TimespanService } from "src/app/instant-analysis/services/timespan/timespan.service";
import { MarkerBuilder } from "../marker-builder";

/**
 * Define o conteúdo de um marker de estação.
 */
export class StationMarkerBuilder implements MarkerBuilder {

  /**  */
  private columnSpecialArgs = {
    'percent': new Set(['percent']),
    'time': new Set(['total', 'nfraca', 'nmoderada', 'nforte', 'nmuitoforte']),
  };

  constructor(public onClicked: Function) {}
  
  createMarker(feature: Feature<Point>, layerParams: LayerParams) {

    let { selectedTimestamp } = layerParams;
    let [ long, lat ] = feature.geometry.coordinates;
    let color = feature.properties.color[selectedTimestamp];
    let marker = new Marker({ color: color }).setLngLat([long, lat]);
    return marker;
  }

  createPopupContent(feature: Feature<Point>, layerParams: LayerParams) {

    let { selectedTimestamp, timeColumns } = layerParams;
    let timeResolutionText = timeColumns.find(t => t.name == selectedTimestamp)?.text;
 
    let valueText = this.format(feature.properties[selectedTimestamp], selectedTimestamp);
    let { nome_estacao_original, fonte } = feature.properties;

    let timeResolutionCompletenessPercentCol = `porcent_${selectedTimestamp}`;
    let completenessPercent = feature.properties[timeResolutionCompletenessPercentCol];
    
    let percentParagraph = completenessPercent == null ? '' : 
      `<p style="text-align: center;">Completude: ${completenessPercent}%</p>`;

    let content = `<h3 style="text-align: center;font-weight: bold;">
      ${nome_estacao_original}</h3>
      <p style="text-align: center;">Fonte: ${fonte}</p>
      ${percentParagraph}
      <p style="text-align: center;">${timeResolutionText}: ${valueText}</p>`;

    let popup = new Popup({offset: 25}).setHTML(content);

    return popup;
  }

  /**
   * 
   * @param value 
   * @param column 
   * @returns 
   */
  private format(value: number, column: string) {
    let valueType = this.getSpecialArgs(column);

    if (valueType == '%') {
      return `${value.toFixed(2)} ${valueType}`;
    }
    if (valueType == 'dhm') {
      return TimespanService.secondsToFormattedText(value);
    }
    if (valueType == 'int') {
      return value.toString();
    }
    return value.toFixed(2);
  }


  /**
   * 
   * @returns 
   */
   private getSpecialArgs(selectedColumn: string): string {
    
    if (this.columnSpecialArgs.percent.has(selectedColumn)) {
      return '%';
    }

    if (this.columnSpecialArgs.time.has(selectedColumn)) {
      return 'dhm';
    }

    return '';
  }
}